import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { LinkProps } from '@repo/ui/src/types/link';

interface Props {
  title?: string;
  postDescription?: string;
  darkMode?: boolean;
  className?: string;
  isAnimating?: boolean;
  link?: LinkProps;
}

const PostTimerBlock = ({
  title,
  postDescription,
  darkMode,
  className,
  isAnimating,
  link,
}: Props) => {
  return (
    <div
      className={classNames(
        'z-101 flex flex-col items-center justify-center text-center transition-opacity duration-1000 ease-in-out delay-[2s] px-5',
        isAnimating ? 'opacity-100' : 'opacity-0 pointer-events-none',
        className,
      )}
      data-testid="post-timer-block"
    >
      <div className={classNames(darkMode ? 'text-white' : 'text-gray-800')}>
        <h2 className="tra-text-web-heading-2 transition-opacity">{title}</h2>
      </div>
      <hr className={classNames('border-2 w-10 border-brand-300 my-4')} />
      <p
        className={classNames(
          'tra-text-web-body-xl max-w-[700px]',
          darkMode ? 'text-white' : 'text-gray-800',
        )}
      >
        {postDescription}
      </p>
      {link?.displayName && (
        <Button
          {...link}
          as={Anchor}
          className={classNames(
            'mt-8 px-6 py-2 rounded-md transition-colors',
            darkMode
              ? 'bg-orange-500 hover:bg-orange-600 text-white'
              : 'bg-orange-500 hover:bg-orange-600 text-white',
          )}
        >
          {link.displayName}
        </Button>
      )}
    </div>
  );
};

export default PostTimerBlock;
